var sb = require('@sb/util')

var config = require('@sb/config')
var axios = require('axios')

axios.defaults.baseURL = config.ApiURL
axios.defaults.withCredentials = false
// axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.timeout = 60 * 1000
// disable xsrf cookie to avoid preflight request
// (if xsrf cookie exist -> axios set header X-XSRF-TOKEN -> preflight request)
axios.defaults.xsrfCookieName = null
axios.defaults.transformRequest.push(function(data, headers) {
	if (data) headers['Content-Type'] = 'text/plain'
	return data
})

axios.interceptors.response.use(
	function(response) {
		const errorCode = (response && response.data && response.data.error) || ''
		if (!errorCode) return response
		api.onError(errorCode)
		return response
	},
	function(error) {
		const errorCode = (error && error.response && error.response.data && error.response.data.error) || ''
		if (!errorCode) return Promise.reject(error)
		api.onError(errorCode)
		return Promise.reject(error)
	},
)

const post = (url, body, options) => axios.post(url, body, options).then(resp => resp.data)

const get = (url, options) => axios.get(url, options).then(resp => resp.data)

var store = {}

var api = {
	setStore(sto) {
		store = sto
	},

	listConversations: (options = {}) => {
		const params = Object.assign({}, options, {
			user_id: store.user.id,
			'x-user-mask': store.mask,
			integration_id: `${store.user.account_id}.subizv4.subikon`,
		})
		return get('/conversations', {params})
	},

	sendBatchRequest: (batchName, ops) => post('/batch2/' + batchName, {ops}),

	getMessages: (convoId, limit, start_id) => {
		const params = {'x-user-mask': store.mask, limit, start_id}
		return get(`/conversations/${convoId}/messages`, {params})
	},

	get: get,

	start: (extraData = {}, convoId) => {
		const data = {
			starter_id: store.user.id,
			starter_type: 'user',
			integration_id: `${store.user.account_id}.subizv4.subikon`,
		}

		if (extraData) {
			for (let key in extraData) {
				data[key] = extraData[key]
			}
		}

		const options = {params: {'x-user-mask': store.mask}}

		if (convoId) {
			return post(`/conversations/${convoId}`, {request: data, state: 'active'}, options)
		}
		return post(`/conversations`, data, options)
	},

	sendConvoEvent: (convoId, ev) =>
		post(`/conversations/${convoId}/messages`, ev, {params: {'x-user-mask': store.mask}}),

	end: cid => post(`/conversations/${cid}/ended`, null, {params: {'x-user-mask': store.mask}}),

	markAsReceived: (convoId, messageId) =>
		post(`/conversations/${convoId}/messages/${messageId}/receive`, null, {params: {'x-user-mask': store.mask}}),

	markAsSeen: (convoId, messageId) =>
		post(`/conversations/${convoId}/messages/${messageId}/seen`, null, {params: {'x-user-mask': store.mask}}),

	getConversation: convoId => get(`/conversations/${convoId}`, {params: {'x-user-mask': store.mask}}),

	sendEvent: data => post(`/users/${store.user.id}/events`, data, {params: {'x-user-mask': store.mask}}),

	sendTyping: convoId => post(`/conversations/${convoId}/typing`, null, {params: {'x-user-mask': store.mask}}),

	sendPresence: device => {
		return api.sendEvent({
			by: {id: store.user.id, device: device},
			type: 'presence_updated',
			object: 'presence',
			data: {presence: {pinged: +new Date()}},
		})
	},

	sendContent: function(device, pageUrl, pageTitle) {
		return api.sendEvent({
			by: {id: store.user.id, device: device},
			type: 'content_viewed',
			object: 'content',
			data: {content: {url: pageUrl, title: pageTitle}},
		})
	},

	presign: file =>
		post(`/accounts/${store.user.account_id}/files`, {
			account_id: store.user.account_id,
			name: file.name,
			size: file.size,
			type: file.type,
		}),

	uploadToS3: async files => {
		let result = []

		for (let file of files) {
			const presignResponse = await api.presign(file)
			const uploadResponse = await axios.put(presignResponse.signed_url, file, {
				withCredentials: false,
				headers: {'Content-Type': file.type},
			})

			if (uploadResponse.status === 200) {
				let path = `/accounts/${store.user.account_id}/files/${presignResponse.id}`
				const data = await post(path, {account_id: store.user.account_id})
				result.push(data)
			}
		}

		return result
	},

	recordDomain: params => get(`${config.BackendURL}/v4/pageview`, {params}),

	updateFcmToken: token =>
		post(`/notification-tokens/${token}`, {platform: 'desktop'}, {params: {'x-user-mask': store.mask}}),

	deleteFcmToken: token => post(`/notification-tokens/${token}/delete`, null, {params: {'x-user-mask': store.mask}}),

	getChallenge: accid => post(`/accounts/${accid}/scrypt-challenges`),

	getUser: userid => get(`/users/${userid}`, {params: {'x-user-mask': store.mask}}),

	createUser: async function(accid) {
		var loadCreateUser = () => import(/* webpackChunkName: "create-user" */ './create_user.js')
		let CU = await loadCreateUser()

		let created = false
		let user = {}
		let count = 0

		while (!created && count < 10) {
			count++
			const challenge = await this.getChallenge(accid)
			console.log('challenge', challenge)

			const answer = await CU.findAnswer(challenge)
			console.log('answer', answer)

			const data = {challenge_id: challenge.id, answer: '' + answer}

			try {
				user = await post(`/accounts/${accid}/scrypt-challenges/users`, data)
				// const resp = { error: 'wrong_answer' }
			} catch (error) {
				const code = sb.get(error, 'response.data.error', '')
				if (code === 'wrong_answer') {
					console.log('wrong answer: get new challenge')
					await sb.sleep(1000)
					continue
				}

				throw error
			}

			created = true
		}

		return user
	},

	updateUser: data => post(`/users/${store.user.id}`, data, {params: {'x-user-mask': store.mask}}),

	getGeoIP: () => get(`${config.BackendURL}/v4/geoip`),

	getUserSetting: () =>
		get(`/accounts/${store.user.account_id}/widgets/${store.user.id}`, {
			params: {'x-user-mask': store.mask},
		}),

	updateUserSetting: setting =>
		post(`/accounts/${store.user.account_id}/widgets/${store.user.id}`, setting, {
			params: {'x-user-mask': store.mask},
		}),

	// deprecated
	getAccountSetting: () => get(`/accounts/${store.user.account_id}/widgets`),

	subscribeWsEvents: (connectionId, events) =>
		post(
			`/accounts/${store.user.account_id}/ws/${connectionId}/events`,
			{events},
			{params: {'x-user-mask': store.mask}},
		),

	sendImpression: impression =>
		post(`/accounts/${store.user.account_id}/campaigns/${impression.campaign_id}/impressions`, impression, {
			params: {'x-user-mask': store.mask},
		}),

	sendConversion: conversion =>
		post(`/accounts/${store.user.account_id}/campaigns/${conversion.campaign_id}/conversions`, conversion, {
			params: {'x-user-mask': store.mask},
		}),

	setGoalReached: (ucStatus) =>
		post(`/accounts/${store.user.account_id}/campaigns/${ucStatus.campaign_id}/user-campaign-status`, ucStatus, {
			params: {'x-user-mask': store.mask},
		}),
}

export default api
